import { CHCArticleGroup } from "./article-group.component.js";
customElements.define("chc-article-group", CHCArticleGroup);
export {
  CHCArticleGroup
};
//# sourceMappingURL=article-group.js.map
